import React from 'react'
import { Container } from 'semantic-ui-react'
import PageHeader from '../components/PageHeader'
import ShowReviews from '../components/ShowReviews'
import FreeEstimate from '../components/FreeEstimate'

export default function WhyUs() {
  return (
    <>
      <PageHeader
        title="Why Choose Us"
        description="18+ Years of Happy Customers"
        image="/images/tree-climbing.jpg"
        backgroundPositionY="0"
      />
      <Container>
        <div className="why-us"></div>
      </Container>
      <ShowReviews
        title={<h1>The people we have served say it best</h1>}
        showControls={false}
        reviewCount={9}
        showCount={9}
        style={{ paddingTop: '0' }}
        backgroundColor=""
        cardColor="green"
      />
      <FreeEstimate />
    </>
  )
}
